"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function () {
	$(this).on('click', '.dataTable[data-table=orderItems] [data-cancel-order-item], .dataTable[data-table=orderItemsProcessing] [data-cancel-order-item]', function (e) {
		e.preventDefault();
		var orderItemId = $(this).attr("data-cancel-order-item");
		var table = $(this).closest('.dataTable');
		var message = Resx.App.CancelOrderItemConfirmMessage.replace("{0}", $(this).attr("data-cancel-order-item-name")).replace("{1}", $(this).attr("data-cancel-order-item-amount"));
		abp.message.confirm(message, Resx.App.CancelOrderItemConfirmTitle, function (isConfirmed) {
			if (isConfirmed) {
				if (table.length > 0) {
					var api = table.DataTable();
					// console.log(orderItemId);
					orderService.cancelOrderItem(orderItemId).done(function (result) {
						api.ajax.reload(null, false);
					}).fail(function (result) {});
				}
			}
		});

		return false;
	});
};

var _localize = require("linksoft/core/localize");

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = require("jquery");
var orderService = abp.services.api.order;


var Resx = (0, _localize2.default)("App");

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/orderActions.js
// module id = 1077
// module chunks = 1